module.exports = __webpack_public_path__ + "static/media/Piercing-nose.bb4ef9a5.png";